import { useUser } from '@hooks/useUser';
import { isModeE2E, useIsMobile } from '@utils';
import { GroupedMenu } from '../Menu/GroupedMenu';
import { Tooltip } from '../Tooltip/Tooltip';
import { Heading } from '../Typography/Heading';
import { useViewAsMenu } from './hooks/useViewAsMenu';

export const ViewAsMenu = () => {
  const { user } = useUser();
  const isMobile = useIsMobile();
  const { roleDisplayInfo, totalSelected, tooltipTitle, groupedMenuItems } =
    useViewAsMenu();

  if (isMobile || !user.isSuperAdmin || isModeE2E) return null;

  return (
    <GroupedMenu
      buttonContent={
        <Tooltip title={tooltipTitle} position="bottom">
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <Heading
                size="xs"
                color="text-gray-500"
                className="max-w-28 truncate"
              >
                View as: {roleDisplayInfo.summary}
              </Heading>
              {totalSelected > 1 && (
                <Heading size="xs" color="text-gray-500">
                  +{totalSelected - 1}
                </Heading>
              )}
            </div>
          </div>
        </Tooltip>
      }
      groups={groupedMenuItems}
      disableAutoClose
    />
  );
};
